<template>
    <div class="member_share">
        <div class="hd">
            <p>当前推广佣金：{{share_detail.tuiguang}}</p>
            <p>{{share_detail.tuiguang_tips}}</p>
        </div>
        <div class="tit">
            <i class="icon icon-1"></i>会员数
        </div>
        <div class="bd_1">
            <div class="item">
                <p class="num">{{share_detail.all_count}}</p>
                <p class="desc">全部人数(人)</p>
            </div>
            <div class="item">
                <p class="num">{{share_detail.vip_count}}</p>
                <p class="desc">已开通VIP(人)</p>
            </div>
            <div class="item">
                <p class="num">{{share_detail.nvip_count}}</p>
                <p class="desc">未开通VIP(人)</p>
            </div>
            <div class="item">
                <p class="num">{{share_detail.over_count}}</p>
                <p class="desc">已过期VIP(人)</p>
            </div>
        </div>
        <!-- <div class="tit">
            <i class="icon icon-2"></i>直推金额
        </div>
        <div class="bd_2">
            <div class="item">
                <p class="num">$ 200</p>
                <p class="desc">推广金额(元)</p>
            </div>
            <div class="item">
                <p class="num">$ 200</p>
                <p class="desc">总消费(元)</p>
            </div>
            <div class="item">
                <p class="num">$ 200</p>
                <p class="desc">今日提成(元)</p>
            </div>
        </div> -->
        <div class="tit">
            <i class="icon icon-3"></i>推广成功人数：<span>{{share_detail.ok_count}}</span>人
        </div>
        <div class="tit">
            <i class="icon icon-4"></i>推广链接
        </div>
        <div class="bd_4">
            <input class="text" type="text" :value="promotion_link" autocomplete="off">
            <div class="btn" @click="clickCopy">复制</div>
        </div>
    </div>
</template>

<script>    
    import { mapGetters } from 'vuex';
    import { shaoreDetail } from '@/api/user.js';
    export default {
        data() {
            return {
                promotion_link: "",
                share_detail:{}
            };
        },    
        created() {
            shaoreDetail().then((response)=>{
                if(response.data.code == 200) {
                    this.share_detail = response.data.data;
                } else {
                    this.$message.error(response.data.msg);
                }
            })
        },
        watch:{
            invitation_code: {
                handler: function(val){
                    this.promotion_link = location.protocol + "//"+ location.host + "/#/?code=" + val;
                },
                immediate: true
            }
        },
        computed: {
            ...mapGetters(['token','invitation_code'])
        },
        methods: {
            clickCopy() {
                this.$copyText(this.promotion_link).then((e) => {
                    this.$message.success('复制成功')
                }, (e) => {
                    this.$message.error('复制失败')
                })
            } 
        }
    }
</script>

<style lang="scss">
    .member_share {     
        padding: 15px 12px;
        box-sizing: border-box;
        .hd {
            background: #FAEADA;
            padding: 12px;
            border: 1px solid #DDA76B;
            font-size: 14px;
            color: #e90e0e;
        }
        .tit {
            height: 45px;
            display: flex;
            align-items: center;
            border-top: 2px solid #E0BB8F;
            background: #EDDCCC;
            box-sizing: border-box;
            color: #88522a;
            font-size: 18px;
            padding-left: 15px;
            margin-top: 12px;
            span {
                color: #ff4545;
            }
        }
        .icon {
            background-repeat: no-repeat;
            background-position: center center;
            height: 40px;
            width: 40px;
            display: inline-block;
        }
        .icon-1 {
            background-image: url('../../assets/images/member/icon_1.png');
        }
        .icon-2 {
            background-image: url('../../assets/images/member/icon_2.png');
        }
        .icon-3 {
            background-image: url('../../assets/images/member/icon_3.png');
        }
        .icon-4 {
            background-image: url('../../assets/images/member/icon_4.png');
        }
        .bd_1 {
            display: flex;
            padding-top: 12px;
            justify-content: center;
            .item {
                height: 70px;
                width: 152px;
                text-align: center;
                border-radius: 10px;
                border: 1px solid #E7C69D;
                background: #FFF6E7;
                display: flex;
                flex-flow: column;
                justify-content: center;
                + .item {
                    margin-left: 16px;
                }
                .num {
                    color: #ff952d;
                    font-size: 18px;
                }
                .desc {
                    color: #c58c39;
                    font-size: 14px;
                }
            }
        }
        .bd_2 {
            display: flex;
            padding-top: 12px;
            justify-content: center;
            .item {
                height: 70px;
                width: 200px;
                text-align: center;
                border-radius: 10px;
                background: #B3771F;
                color: #fff;
                display: flex;
                flex-flow: column;
                justify-content: center;
                + .item {
                    margin-left: 20px;
                }
                .num {
                    font-size: 18px;
                }
                .desc {
                    font-size: 14px;
                }
            }
        }
        .bd_4 {
            display: flex;
            padding-top: 12px;
            input{
                outline:none
            } 
            .text {
                width: 565px;
                height: 45px;
                box-sizing: border-box;
                padding-left: 16px;
                border-radius: 5px;
                background: #FFF6E7;
                border: 1px solid #DDA76B;
                color: #88522a;
                font-size: 14px;
            }
            .btn {
                width: 90px;
                height: 45px;
                line-height: 45px;
                text-align: center;
                box-sizing: border-box;
                border-radius: 5px;
                margin-left: 10px;
                background: linear-gradient(#BC8533, #9A681F);
                color: #fff;
                font-size: 18px;
                cursor: pointer;
                &:hover {
                    background: linear-gradient(#9A681F, #BC8533);
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/member/share.vue